import { useMemo } from 'react';

import { InputsTemplate } from '../../../inputs/InputsTemplate';
import { FormTemplate } from '../../FormTemplate';

import { mock } from '../../../../../lib/mocks/add-owner-comment';

import { useRealtyMutations } from '../../../../../hooks/useRealtyMutations';
import { showSuccess, showError } from '../../../../../utils/ui';
import { successMessages } from '../../../../../data/constants';

export const AddOwnerComment = ({ realty = {}, handleClose = () => {} }) => {
  const { updateRealty } = useRealtyMutations();

  // If there's a saved comment.comment_comment (user has edited before), use it
  // If not,use backend values description and link
  // Can reset to default values by clearing info and submitting (Line 46-52)

  const formInitialValues = useMemo(() => {
    const savedComment = realty?.comment?.comment_comment;

    if (savedComment && savedComment.trim().length > 0) {
      return {
        owner_comment: savedComment,
      };
    }
    const parts = ['COMMENTS:'];

    if (realty?.text_description?.description_text_en) {
      parts.push(`DESCRIPTION: ${realty.text_description.description_text_en}`);
    }

    if (realty?.main?.external_link) {
      parts.push(`LINK: ${realty.main.external_link}`);
    }

    const combinedText = parts.join('\n\n');

    return {
      owner_comment: combinedText,
    };
  }, [realty]);

  const handleSubmit = async values => {
    try {
      const commentText = values.owner_comment?.trim() || '';

      const payload = {
        comment_comment: commentText,
      };

      await updateRealty({
        id: realty.id,
        data: payload,
      }).unwrap();

      showSuccess(
        successMessages.commentUpdated || 'Comment updated successfully'
      );
      handleClose();
    } catch (error) {
      showError(error?.data?.message || 'Failed to update comment');
    }
  };

  return (
    <FormTemplate
      initialValues={formInitialValues}
      handleSubmitForm={handleSubmit}
      buttonText={'Save'}
      bgColor={'bg-purpleColor border-purpleColor'}
    >
      {formProps => (
        <InputsTemplate
          formProps={formProps}
          inputsList={mock}
        />
      )}
    </FormTemplate>
  );
};
